module.exports = __webpack_public_path__ + "img/trade-frequency.b02e5aea.png";